export default __webpack_public_path__ + "static/media/thunder.19ff3c30.svg";